import styled, { css } from "styled-components";
import { Card } from "../../card/card";
import { Button } from "../../button/button";

export const ChapterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const Wrapper = styled(Card)`
  clip-path: ${({ theme }) => `inset(0 round ${theme.sizes.radius.lg})`};
  position: relative;
  background: ${({ theme }) =>
    theme.mode === "dark" ? theme.colors.card : "#fff"};
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ChapterInfo = styled(Flex)`
  flex: 1; /* Ocupa o espaço restante */
  flex-direction: column;
  align-items: baseline;
  gap: 5px;
`;

export const ChapterTitle = styled.p`
  color: ${({ theme }) => theme.colors.text};
  font-size: ${({ theme }) => theme.sizes.font.md};
`;

export const ChapterTime = styled.span`
  color: ${({ theme }) => theme.palette.gray[500]};
  font-size: ${({ theme }) => theme.sizes.font.xs};
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const ChapterDownload = styled(Button)`
  background: transparent;
  height: 40px;
  width: 40px;
  color: ${({ theme }) => theme.colors.primary};
`;

export const ControlButtonPlay = styled(Button)`
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const WaveContainer = styled.div`
  display: none;
`;

// type ControllPlayContainerProps = {
//   isPlaying?;
//   isLoading?;
// };

export const ControllPlayContainer = styled.div`
  ${({ isPlaying, isLoading }) =>
    (isPlaying || isLoading) &&
    css`
      ${WaveContainer} {
        display: flex;
        justify-content: center;
        width: 40px;
      }
      ${ControlButtonPlay} {
        display: none;
      }
      &:hover {
        ${WaveContainer} {
          display: none;
        }
        ${ControlButtonPlay} {
          display: flex;
        }
      }
    `}
`;

export const ChapterProgress = styled.div`
  height: 3px;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 10px;
  span {
    background-color: ${({ theme }) => theme.colors.primary};
    width: ${(props) => props.progress || 0}%;
    height: 3px;
    display: flex;
    border-radius: 10px;
  }
`;
